import {ApiClientProvider} from "../../../../core/data-access/http-client/clients/api-client-provider.service";
import {IAccountsApiClient} from "./i-accounts-api.client";
import {AccountsApiClient} from "./accounts.api.client";
import {AccountsApiInMemoryClient} from "./accounts.api.inmemory.client";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class AccountsApiClientProvider extends ApiClientProvider<IAccountsApiClient> {

    constructor(private client: AccountsApiClient, private inMemoryClient: AccountsApiInMemoryClient) {
      super();
    }

    protected override getInMemoryClient(): IAccountsApiClient {
        return this.inMemoryClient;
    }
    protected override getApiClient(): IAccountsApiClient {
        return this.client;
    }
}
